import React, { useState, useEffect } from "react";
import styles from "./PressRelease.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { Icon } from "../../assets/Icons.tsx";
import classNames from "classnames";
import { mediaPressReleaseData } from "../../redux/slices/mediaSlice.js";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";


const PressRelease: React.FC = () => {
  const [showSingleRelease, setShowSingleRelease] = useState(false);
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");

  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "News & Media", link: "/news-and-media" },
    { title: "Press Releases", link: "" },
  ];

  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
      <div className={`${styles.PressRelease} mt-5`}>
        <div className="section">
          <div className="container-fluid">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <p className="heading">Press releases</p>
                  <p className="para">
                    Find the latest updates on Aptech’s initiatives,
                    achievements, partnerships, and events here.
                  </p>
                </div>
              </div>
            </div>
            <div>
              {!showSingleRelease && (
                <ReleaseList
                  showSingleRelease={showSingleRelease}
                  setShowSingleRelease={setShowSingleRelease}
                  setDescription={setDescription}
                  setTitle={setTitle}
                  setDate={setDate}
                />
              )}
            </div>
            <div>
              {showSingleRelease && (
                <Release
                  setShowSingleRelease={setShowSingleRelease}
                  title={title}
                  description={description}
                  date={date}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      </motion.div>
    </>
  );
};

export default PressRelease;

const ReleaseList = ({
  showSingleRelease,
  setShowSingleRelease,
  // setClickedId,
  setDescription,
  setTitle,
  setDate,
}) => {
  const [pressReleaseData, setPressReleaseData] = useState([]);
  const [filteredRelease, setFilteredRelease] = useState([]);

  const viewRelease = (title, description, date) => {
    setDescription(description);
    setTitle(title);
    setDate(date);

    window.scrollTo({ top: 0, behavior: "auto" });
    setShowSingleRelease(true);
  };

  const startYear = 2012;
  const endYear = new Date().getFullYear();
  const years = [];

  for (let year = endYear; year >= startYear; year--) {
    years.push(`${year}`);
  }
  const [selectedYear, setSelectedYear] = useState(
    localStorage.getItem("selectedYear") || years[0]
  );

  const [yearRange, setYearRange] = useState([
    new Date().getFullYear(),
    new Date().getFullYear() - 4,
  ]);
  const [activeTab, setActiveTab] = useState(yearRange[0]);
  const [loading, setLoading] = useState(true);

  const handleNext = () => {
    setYearRange((prev) => [prev[0] - 5, prev[1] - 5]);

    console.log(yearRange, "yearRange555");
    setActiveTab(yearRange[1] - 1);
  };

  const handlePrevious = () => {
    setYearRange((prev) => [prev[0] + 5, prev[1] + 5]);
    console.log(yearRange, "llll");
    setActiveTab(yearRange[0] + 5);
  };

  const handleTabClick = (year) => {
    setActiveTab(year);
    setSelectedYear(year);
  };

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const fetchPressReleaseData = async () => {
      setLoading(true);
      try {
        const data = await dispatch(
          mediaPressReleaseData(selectedYear)
        ).unwrap();
        setPressReleaseData(data?.press_releases);
        setLoading(false);
        console.log(data?.press_releases, "jk");
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPressReleaseData();
  }, [dispatch, selectedYear]);
  useEffect(() => {
    const filterData = () => {
      if (activeTab) {
        setSelectedYear(activeTab);
      }
      const filteredYearData = pressReleaseData?.find(
        (item) => item?.year?.toString() === selectedYear.toString()
      );
      console.log(filteredYearData, "filteredYearData");

      let filteredFiles = filteredYearData?.details || [];

      console.log(filteredFiles, "filteredFiles");
      setFilteredRelease(filteredFiles);
    };

    filterData();
  }, [selectedYear, pressReleaseData, yearRange, activeTab]);

  useEffect(() => {
    console.log(location.pathname);

    // Clear specific keys in localStorage when the route changes
    const clearLocalStorageOnNavigation = () => {
      localStorage.removeItem("selectedYear"); // Persist the year selection
    };

    clearLocalStorageOnNavigation();
  }, [location.pathname]); // Run whenever the path changes

  const extractDay = (date) => {
    const dateObj = new Date(date);
    return dateObj.getDate();
  };

  const extractMonth = (date) => {
    try {
      const dateObj = new Date(date);
      if (isNaN(dateObj)) throw new Error("Invalid date format");
      return dateObj?.toLocaleString?.("default", { month: "short" });
    } catch (error) {
      console.error("Error extracting month:", error.message);
      return "Invalid Date";
    }
  };

  const nextDisabled = yearRange[1] > 2012 ? false : true;

  return (
    <>
      {!showSingleRelease && (
        <>
          <div className="row mb-4 g-0">
            <div className="col-lg-12 col-md-12">
              <div className="container">
                <div className={`${styles.filters}`}>
                  <div
                    className={`${styles.year} d-flex justify-content-center align-items-center`}
                  >
                    <button
                      onClick={handlePrevious}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "white",
                      }}
                      disabled={yearRange[0] >= new Date().getFullYear()}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Icon
                        name="dropdownLeftArrow"
                        color="white"
                        width="25px"
                        height="25px"
                      />
                    </button>
                    <span
                      className="d-flex justify-content-center align-items-center"
                      style={{ fontSize: "24px" }}
                    >
                      <Icon name="calender" color="white" />
                    </span>
                    <span className=" mb-0">&nbsp;Year |&nbsp;</span>

                    <div className={styles.customSelect}>
                      <div className={` mb-0 ${styles.textPadding}`}>
                        <span
                          className="text-center"
                          style={{ color: "white" }}
                        >
                          {yearRange[1] !== ""
                            ? `${yearRange[0]} - ${yearRange[1]}`
                            : yearRange[0]}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={handleNext}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "white",
                      }}
                      disabled={nextDisabled}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Icon
                        name="dropdownRightArrow"
                        color="white"
                        width="25px"
                        height="25px"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <ul
                className={`nav nav-pills ${styles.navPills} overflow-auto`}
                id="pills-tab"
                role="tablist"
                style={{ whiteSpace: "nowrap" }}
              >
                {Array.from(
                  { length: yearRange[0] - yearRange[1] + 1 },
                  (_, i) => yearRange[0] - i
                )
                  // .filter((year) => year >= 2015) // Only include years >= 2015
                  .map((year) => (
                    <li
                      key={year}
                      className="nav-item flex-shrink-0"
                      role="presentation"
                    >
                      <button
                        className={`para mb-0 ${styles.navLink} ${
                          activeTab === year ? styles.navLinkActive : ""
                        }`}
                        onClick={() => handleTabClick(year)}
                        type="button"
                        role="tab"
                        aria-controls={`pills-${year}`}
                        aria-selected={activeTab === year}
                      >
                        {year}
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

         

          {!loading ? (
            <div className="container">
              <div className={styles.header}>
                <div className="row">
                  <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                    <p className={`para caps ${styles.colPadding}`}>
                      <strong>Date</strong>
                    </p>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-7 col-7">
                    <p className="para caps">
                      <strong>Title</strong>
                    </p>
                  </div>
                  <div className="col-lg-1 col-md-2 col-sm-3 col-3">
                    <p className={`para caps ${styles.ViewColumnHeading}`}>
                      <strong>View</strong>
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                {filteredRelease?.map((card, index) => (
                  <div className={styles.brandCard} key={index}>
                    <div className="row">
                      <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                        <div
                          className={`${styles.date} ${styles.colContentPadding}`}
                        >
                          <p
                            className={`para ${styles.cardDate} ${styles.cardMonth} mb-0 text-center`}
                          >
                            {extractMonth(card?.publish_date)}
                          </p>
                          <p
                            className={`${styles.cardDay} ${styles.cardDate} mb-0 text-center`}
                          >
                            {extractDay(card?.publish_date)}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-8 col-sm-7 col-7">
                        <p className={`para ${styles.cardTitle} mb-0`}>
                          {card.title}
                        </p>
                      </div>
                      <div className="col-lg-1 col-md-2 col-sm-3 col-3">
                        <span
                          onClick={() =>
                            viewRelease(
                              card?.title,
                              card?.long_description,
                              card?.publish_date
                            )
                          }
                          style={{ fontSize: "24px", cursor: "pointer" }}
                        >
                          <Icon
                            name="eyeIcon"
                            color="#036995"
                            width="40px"
                            height="40px"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  
                ))}
                {filteredRelease?.length === 0 && (
                  <div className={styles.brandCard}>
                    <p className="subHeading text-center caps mt-4 mb-4">
                      No Data available
                    </p>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <p className="para text-center pt-3">Loading...</p>
          )}
        </>
      )}
    </>
  );
};

const Release = ({ setShowSingleRelease, title, description, date }) => {
  const goBack = () => {
    setShowSingleRelease(false);
    localStorage.setItem("selectedYear", new Date(date).getFullYear()); // Persist the year selection
  };
  const convertDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-US", {
      month: "short", // Short month name (e.g., Dec)
      day: "numeric", // Day of the month (e.g., 27)
      year: "numeric", // Full year (e.g., 2024)
    });
  };

  return (
    <div className="container">
      <div className={styles.Release}>
        <div>
          <div className={classNames(styles.back)} onClick={goBack}>
            <span style={{ fontSize: "20px" }}>
              <Icon name="backArrow" />
            </span>
            Back
          </div>

          <div>
            <p className={`${styles.customSubheading} subHeading`}>{title}</p>
          </div>

          <div className="d-flex justify-para-start align-items-center">
            <p className="para" style={{ color: "var(--primary)" }}>
              <span style={{ fontSize: "30px", paddingRight: "8px" }}>
                <Icon name="calender" color="var(--primary)" />
              </span>
              {convertDate(date)}
            </p>
          </div>

          <div
            className={`para ${styles.pressReleaseDescriptionDiv}`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <div className="w-100 d-flex justify-content-end">
            <div
              className={`${classNames(styles.back, styles.bottomBack)}`}
              onClick={goBack}
            >
              <span style={{ fontSize: "20px" }}>
                <Icon name="backArrow" />
              </span>
              Back
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
